import {Prompt, PicLink, EventBanner, Quicklink, EventResources, ScrollReset} from './obj.js'

import mcpc1 from './img/MCPC/MCPC2024.webp'
import mcpc2 from './img/MCPC/PXL_20231007_023919694.PANO.webp'
import mcpc3 from './img/MCPC/PXL_20241012_065511471.webp'
import mcpc4 from './img/MCPC/mcpc23v2.webp'

import alg from './icons/compalg.png'
import dmoj from './icons/dmoj_white.png'
import leetcode from './icons/leetcode.svg'
export default function MCPC(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>MCPC</EventBanner>
            <section className= "twocol">
                <Prompt text = "Workshops >>">MCPC is a more advanced competition that allows participants to showcase their programming skills. This competition is crafted by our most senior members over the course of a year and focusses on novel and experimental problems that focus on creativity and abstract thought.
                    <br></br>
                    <br></br>
                    This event has a $1000 dollar prize pool, awarded to competitors based on placement. <br></br>
                </Prompt>
                <div className = 'twobytwo'>
                    <PicLink src = {mcpc1}></PicLink>
                    <br/>
                    <br/>
                    <PicLink src = {mcpc2}></PicLink>
                </div>
            </section>
            <section className= "twocol">

                <div className = 'twobytwo'>
                    
                    <br/>
                    <PicLink src = {mcpc3}></PicLink>
                    <PicLink src = {mcpc4}></PicLink>
                    <br/>
                    
                </div>
                <EventResources>
                    <Quicklink src = {alg} path = 'https://cp-algorithms.com/'>CP-Algorithms</Quicklink>
                    <Quicklink src = {dmoj} path = '/dmoj'>DMOJ</Quicklink>
                    <Quicklink src = {leetcode} path = 'https://leetcode.com/'>Leetcode</Quicklink>
                </EventResources>
            </section>

        </main>
    </>)
}